import axios from 'axios';
import { envVariables } from "../config/global.config";
import { showDangerMessage } from '../utils/notification.util';

const getToken = () => {
  return localStorage.getItem('ACCESS_TOKEN');
};

const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));
const apiClient = axios.create({
  baseURL: `${envVariables.API_URL}/api`,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});


apiClient.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);


const axiosGet = async (url, params = {}) => {
  try {
    const response = await apiClient.get(url, { params });
    await delay(50);
    if (response?.data?.success === false) {
      throw new Error(response?.data?.message);
    }
    return response.data;
  } catch (error) {
    handleError(error);
    throw error;
  }
};

const axiosPost = async (url, data) => {
  try {
    const response = await apiClient.post(url, data);
    if (response?.data?.success === false) {
      throw new Error(response?.data?.message);
    }
    return response.data;
  } catch (error) {
    handleError(error);
    throw error;
  }
};

const axiosPatch = async (url, data) => {
  try {
    const response = await apiClient.patch(url, data);
    if (response?.data?.success === false) {
      throw new Error(response?.data?.message);
    }
    return response.data;
  } catch (error) {
    handleError(error);
    throw error;
  }
};


const axiosDelete = async (url) => {
  try {
    const response = await apiClient.delete(url);
    if (response?.data?.success === false) {
      throw new Error(response?.data?.message);
    }
    return response.data;
  } catch (error) {
    handleError(error);
    throw error;
  }
};


const handleError = (error) => {
  if (error.response) {
    // Server responded with a status other than 2xx
    console.error('Server Error:', error.response.data);
    if (error.response.status === 401) {
      // Unauthorized
      localStorage.removeItem('ACCESS_TOKEN');
      window.location.href = '/login';
      showDangerMessage('Session expired. Please login again.')
      return;
    }
  } else if (error.request) {
    // No response received from server
    console.error('Network Error:', error.request);
    if(error.code === 'ERR_NETWORK') {
      showDangerMessage('Server Error. Please contact administrator.');
    }
  } else {
    // Other errors
    console.error('Error:', error.message);
  }
};

export { axiosGet, axiosPost, axiosPatch, axiosDelete };
